import { render, staticRenderFns } from "./ReportDetial.vue?vue&type=template&id=3845c9b4&scoped=true"
import script from "./ReportDetial.vue?vue&type=script&lang=js"
export * from "./ReportDetial.vue?vue&type=script&lang=js"
import style0 from "./ReportDetial.vue?vue&type=style&index=0&id=3845c9b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845c9b4",
  null
  
)

export default component.exports